/* WizardTreeViewComponent.js */

"use strict";
const _ = require("lodash");
const Registrations = require("../../../../../RegistrationNamespaces");
const EventEmitter = require("events").EventEmitter;
const Renderer = require("./WizardTreeViewRenderer");

class WizardTreeViewComponent extends EventEmitter {
    constructor(logger, gameEditor, router, userSession) {
        super();
        this._logger = logger;
        this._gameEditor = gameEditor;
        this._router = router;
        this._userSession = userSession;
        this._wizardFeed = undefined;

        this._registerListeners();

        // Retrieve only the wizards for this app.
        this._mongoQuery = {
            $or: [
                {
                    appContext: {
                        $exists: false
                    }
                },
                {
                    "appContext.WKF": {
                        $exists: true
                    }
                }
            ]
        };
        this._initWizardFeed();
        this._renderer = new Renderer(this);
    }
    /*******************************************/
    /* START PRIVATE COMPONENT MODEL METHODS */
    /*******************************************/
    _registerListeners() {
        this._userSession.on("OrganizationChange", (this._onOrganizationChange = this._onOrganizationChange.bind(this)));
    }
    _unregisterListeners() {
        this._userSession.removeListener("OrganizationChange", this._onOrganizationChange);
    }
    _registerWizardFeedListeners() {
        this._wizardFeed.on("EntityAdded", (this._onWizardAdded = this._onWizardAdded.bind(this)));
        this._wizardFeed.on("EntityRemoved", (this._onWizardRemoved = this._onWizardRemoved.bind(this)));
        this._wizardFeed.on("EntityPropertiesUpdated", (this._onWizardUpdated = this._onWizardUpdated.bind(this)));
    }
    _unregisterWizardFeedListeners() {
        if (this._wizardFeed) {
            this._wizardFeed.removeListener("EntityAdded", this._onWizardAdded);
            this._wizardFeed.removeListener("EntityRemoved", this._onWizardRemoved);
            this._wizardFeed.removeListener("EntityPropertiesUpdated", this._onWizardUpdated);
        }
    }
    /*******************************************/
    /* END PRIVATE COMPONENT MODEL METHODS */
    /* START PUBLIC COMPONENT MODEL METHODS */
    /*******************************************/
    get renderer() {
        return this.getRenderer();
    }
    getRenderer() {
        return this._renderer;
    }
    shutdown() {
        this._unregisterListeners();
        this._unregisterWizardFeedListeners();
        return Promise.all([this._renderer.shutdown(), this._wizardFeed.shutdown()]).then(() => {
            this._renderer = undefined;
            this._userSession = undefined;
            this._wizardFeed = undefined;
        });
    }
    /*******************************************/
    /* END COMPONENT MODEL METHODS */
    /* START HANDLER METHODS */
    /*******************************************/
    _onOrganizationChange() {
        this._reestablishWizardFeed();
    }
    /*******************************************/
    /* END HANDLER METHODS */
    /* START PRIVATE METHODS */
    /*******************************************/
    _initWizardFeed() {
        this._wizardFeed = this._gameEditor.WizardEntityDefinition.startWizardsFeed(
            this._userSession.activeOrganization.id,
            this._mongoQuery,
            undefined,
            undefined,
            undefined
        );
        this._wizardFeedProm = this._wizardFeed.whenInitialized().then(() => {
            this._registerWizardFeedListeners();
            this.emit("WizardsInitialized");
        });
    }
    _reestablishWizardFeed() {
        let activeOrgId = this._userSession.activeOrganization.id;
        //If this happens before the initial feed is ready wait...
        Promise.resolve()
            .then(() => {
                return this.whenWizardFeedisReady();
            })
            .then(() => {
                this._wizardFeed.reestablishFeed(activeOrgId, this._mongoQuery, undefined, undefined, {
                    Success: () => {
                        this._logger.trace("WizardExplorerLmrbComponent._reestablishWizardFeed - Feed Reestablished.");
                    },
                    Failure: (err) => {
                        this._logger.warn({ error: err }, "WizardExplorerLmrbComponent._reestablishWizardFeed error.");
                    }
                });
            });
    }
    _onWizardAdded(wiz) {
        this.emit("WizardAdded", wiz);
    }
    _onWizardRemoved(wiz) {
        this.emit("WizardRemoved", wiz);
    }
    _onWizardUpdated(wiz) {
        this.emit("WizardUpdated", wiz);
    }
    /*******************************************/
    /* END PRIVATE METHODS */
    /* START PUBLIC API METHODS */
    /*******************************************/
    get gameEditor() {
        return this._gameEditor;
    }
    get wizardFeed() {
        return this._wizardFeed;
    }
    getWizardFeed() {
        return this._wizardFeed;
    }
    getWizardFromFeed(id) {
        let wiz = null;
        if (this.isWizardFeedReady()) {
            wiz = this._wizardFeed.getInstanceById(id);
        }
        return wiz;
    }
    get wizards() {
        return this.getWizards();
    }
    getWizards() {
        let whizzards = {};
        if (this.wizardFeed) {
            whizzards = this.wizardFeed.getCache();
        }
        return whizzards;
    }
    whenWizardFeedisReady() {
        return this._wizardFeedProm;
    }
    isWizardFeedReady() {
        if (this._wizardFeed && this._wizardFeed.wasPreviouslyInitialized()) {
            return true;
        } else {
            return false;
        }
    }
    launchWizardInstanceEditor(id, viewName = Registrations.WIZARD_INSTANCE_EDITOR_EXECUTION_VIEW, opts = {}) {
        let wizardEntity = this.getWizardFromFeed(id);
        if (wizardEntity) {
            let editorState = {
                    fqn: viewName,
                    ref: wizardEntity.getProperty("name"),
                    startObj: {},
                    wizardEntity: wizardEntity
                },
                launchOpts = {
                    id: id,
                    title: wizardEntity.getProperty("displayName")
                };
            if (_.get(opts, "editorState")) {
                _.merge(editorState, opts.editorState);
            }
            if (_.get(opts, "launchOpts")) {
                _.merge(launchOpts, opts.launchOpts);
            }
            return this._gameEditor.launchWizardEditor(editorState, launchOpts);
        } else {
            return false;
        }
    }
    /*******************************************/
    /* END PUBLIC API METHODS */
    /*******************************************/
}
module.exports = WizardTreeViewComponent;
module.exports.$inject = ["$teve.logger", "gameEditor.gameEditor", "$teve.router", "$teve.userSession"];
module.exports.$displayDetails = {
    type: "View",
    name: "Workflows",
    icon: "common.bomb",
    shown: true
};
